import router from "./router";
import {
  getToken
} from "@/utils/auth";
const whiteList = ['/checkPolicy', '/checkPolicy/details', '/checkPolicy/warranty', '/checkPolicy/details/paymentDetails', '/checkPolicy/details/modifyInformation', '/checkPolicy/details/insured']
router.beforeEach((to, from, next) => {
  if (to.path === "/" && to.query.code !== undefined) {
    next({
      path: "/pay",
      query: {
        code: to.query.code,
        pid: to.query.pid
      }
    });
  } else if (to.path === "/") {
    next({
      path: "/overseas"
    });
  } else if (whiteList.indexOf(to.path) !== -1) {
    if (getToken()) {
      next();
    } else {
      next({
        path: "/login"
      });
    }
  } else {
    next();
  }
});